import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle12() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article12" headerImage="MagdaEhlers.jpg" photographer=" Magda Ehlers, Pexels" />
        <Footer />
    </div>
  )
}
